import React, { useCallback, memo } from "react";

import useStyles from "./styles";

export type Step = {
  label: string;
  key: string;
  required?: boolean;
  dataCy?: string;
  hasError?: boolean;
  component: React.ReactChild;
  action?: Function;
};

interface Props {
  steps: Step[];
  currentStep: string;
  stepsOption: string[];
}

const UISteps = (props: Props) => {
  const { steps, currentStep, stepsOption } = props;
  const classes = useStyles();

  const isStepConcluded = useCallback(
    (step: string) =>
      !currentStep.includes(step) && stepsOption.includes(step) ? "concluded" : "",
    [stepsOption]
  );
  const isStepActive = useCallback(
    (step: string) => (currentStep.includes(step) ? "active" : ""),
    [currentStep]
  );

  const hasStepError = useCallback((stepError?: boolean): string => {
    if (stepError) return "error";

    return "";
  }, []);

  const renderCurrentComponent = () =>
    steps.find((step) => step.key.toLowerCase() === currentStep.toLowerCase())?.component;

  return (
    <section className={classes.modalSection}>
      <header className={classes.modalSectionHeader}>
        <ul className="steps">
          {steps.map((step: Step, index: number) => (
            <li
              onClick={() => step.action && step.action()}
              key={step.key}
              data-cy={step.dataCy}
              className={`step
                ${step.action && "withCursor"}
                ${isStepConcluded(step.key)}
                ${isStepActive(step.key)} 
                ${hasStepError(step.hasError)}`}
            >
              <span>{index + 1}</span>
              {step.label}
              {step.required && <p className={classes.required}>*</p>}
            </li>
          ))}
        </ul>
      </header>
      <section className={classes.modalSectionBody}>{renderCurrentComponent()}</section>
    </section>
  );
};

export default memo(UISteps);
